module.exports = __webpack_public_path__ + "static/Truck24-a8653615d238655d52b7da80586b3486.png";